import styled from '@emotion/styled';

import { BarData, BarStacked1D } from '@arra/core';
import { Bar, BarChart, LabelList, XAxis } from 'recharts';

const NoDataContainer = styled.div`
  width: 100%;
  padding: 16px;
  height: 100%;
  border: 1px dashed rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  display: flex;
  gap: 4px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    text-align: center;
  }
`;

// Local type to describe the items in `data`
interface ScoredCategory extends BarData {
  categoryName: string;
  score: string; // e.g. "20 / 100"
}

const PdfBarStacked1D = ({ result }: { result: BarStacked1D }) => {
  const chartData = (result.data?.data ?? []) as ScoredCategory[];
  if (!chartData.length) {
    return (
      <NoDataContainer>
        <p className="hxb">Aucune donnée</p>
        <p className="hxr">
          Votre score sera affiché dès que vous aurez répondu aux premières
          questions associés
        </p>
      </NoDataContainer>
    );
  }

  return (
    <BarChart
      width={700}
      height={200}
      data={chartData}
      margin={{ top: 20, right: 0, left: 0, bottom: 0 }}
    >
      <XAxis dataKey="categoryName" tick={{ fontSize: 12 }} />
      {result.data!.barData.map((barData: BarData, idx: number) => (
        <Bar
          isAnimationActive={false}
          key={barData.name as string}
          dataKey={barData.name as string}
          stackId="a"
          fill={barData.color as string}
        >
          {idx === result.data!.barData.length - 1 && (
            <LabelList
              dataKey="score"
              position="top"
              content={<ScoreLabel />}
            />
          )}
        </Bar>
      ))}
    </BarChart>
  );
};

const ScoreLabel = (props: any) => {
  const { x, y, value, width } = props;
  return (
    <text x={x + width / 2} y={y - 4} textAnchor="middle" fontSize={12}>
      {roundDivisionInput(value)}
    </text>
  );
};

const roundDivisionInput = (value: string): string => {
  const match = value.match(
    /^\s*(-?\d+(?:\.\d+)?)\s*\/\s*(-?\d+(?:\.\d+)?)\s*$/,
  );

  if (!match) {
    return '';
  }

  const num1 = Number(match[1]);
  const num2 = Number(match[2]);

  if (Number.isNaN(num1) || Number.isNaN(num2)) {
    return '';
  }

  return `${Math.round(num1).toLocaleString('fr-FR')} / ${Math.round(
    num2,
  ).toLocaleString('fr-FR')}`;
};

export default PdfBarStacked1D;
